/** @format */

enum TYPES {
	SET_FILE = 'SET_FILE',
	SET_ERROR_FOR_FILES = 'SET_ERROR_FOR_FILES',
}

export default TYPES;
